import React, { useEffect, useState, useMemo } from 'react';
import ScrollIntoView from '../../client/common/scrollIntoView';
import { useDispatch, useSelector } from 'react-redux';
import { apiService } from '../../client/common/apiCallService';
import { Navigate, useParams } from 'react-router-dom';
import { setClientData } from '../../client/Redux/actions/junoAction';
import { useJunoCommonFunctions } from '../../client/Juno/helpers';
import { displayCurrencyPage } from '../../client/Redux/actions/junoAction';
import Header from '../components/Header';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { useLocation } from 'react-router-dom';
import { IGNORE_HEADER_PATHS } from '../helpers/constant';
import Footer from '../components/footer/Footer';

function Layout(props) {
    const [token, setToken] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();
    const clientData = useSelector(state => state.juno.clientData);
    const apiUrl = useSelector(state => state.config.api_url);
    const { getWhitelistData, logout, useWindowWidth } = useJunoCommonFunctions();
    const { id } = useParams();
    const [selectedLogo, setSelectedLogo] = useState([]);
    const location = useLocation();
    const { pathname } = location;
    const windowWidth = useWindowWidth();

    // Determine if header should be shown
    // Memoize the shouldShowHeader calculation
    const shouldShowHeader = useMemo(() => {
        if (location.pathname.startsWith('/client/bulk-payment')) return false;

        return (
            !IGNORE_HEADER_PATHS.some(path => location.pathname.startsWith(path)) ||
            windowWidth > 1100
        );
    }, [location.pathname, windowWidth]);

    useEffect(() => {
        const activeCurrencyPage = localStorage.getItem('activeCurrencyPage');
        dispatch(displayCurrencyPage(activeCurrencyPage));
    }, []);

    const fetchData = async () => {
        try {
            document.body.classList.add('juno-client-theme');
            setIsLoading(false);
            const token = localStorage.getItem('user_name');
            setToken(token);
            if (!clientData) {
                let clientData;
                const whiteLabelData = await getWhitelistData();
                await apiService(
                    (window.location.hostname === 'localhost' ? apiUrl : '') +
                        '/restapi/get-logedIn-client',
                    {
                        verifyToken: token,
                    },
                    async data => {
                        clientData = data;
                    },
                    err => {
                        console.log(err);
                    },
                );
                const tabSettings = {
                    cryptoTab: clientData.cryptoTab,
                    fiatTab: clientData.fiatTab,
                };
                localStorage.setItem('tabSettings', JSON.stringify(tabSettings));
                const enabledCurrencyPages = [];

                if (clientData.fiatTab === 'Enable') {
                    enabledCurrencyPages.push('fiat');
                }
                if (clientData.cryptoTab === 'Enable') {
                    enabledCurrencyPages.push('crypto');
                }

                // Get current value from localStorage
                const storedCurrencyPage = localStorage.getItem('activeCurrencyPage');

                // Determine valid currency page
                let newActiveCurrencyPage = storedCurrencyPage;

                // If stored value is not valid or not present, pick a default
                if (!storedCurrencyPage || !enabledCurrencyPages.includes(storedCurrencyPage)) {
                    // Prefer fiat as default if available, else fall back to the first enabled tab
                    newActiveCurrencyPage = enabledCurrencyPages.includes('fiat')
                        ? 'fiat'
                        : enabledCurrencyPages[0] || '';

                    if (newActiveCurrencyPage) {
                        localStorage.setItem('activeCurrencyPage', newActiveCurrencyPage);
                        dispatch(displayCurrencyPage(newActiveCurrencyPage));
                    }
                } else {
                    dispatch(displayCurrencyPage(storedCurrencyPage));
                }
                if (whiteLabelData) {
                    const whitelabelId = (clientData && clientData.whiteLabelId) || id;
                    const whiteLabel =
                        whiteLabelData &&
                        whiteLabelData?.whitelabelList.find(e => e.whitelabelId === whitelabelId);
                    // sessionStorage.setItem('logo', `${imageBaseURl}/junoclient/juno-icon.svg`);
                    if (whiteLabel) {
                        const themeColor = whiteLabel.primaryColor || '#18181b';
                        sessionStorage.setItem('primaryColor', themeColor);
                        sessionStorage.setItem('redirectURL', whiteLabel.redirectURL);
                        if (whiteLabel.logo !== undefined) {
                            sessionStorage.setItem('logo', whiteLabel.logo);
                        }
                        if(whiteLabel?.darkLogo !== undefined) {
                            sessionStorage.setItem('darkLogo', whiteLabel.darkLogo);
                        }
                        document.documentElement.style.setProperty('--theme-color', themeColor);
                        document.documentElement.style.setProperty(
                            '--btn-background-hover',
                            themeColor,
                        );
                    }
                }

                if (clientData) {
                    dispatch(setClientData(clientData));
                    if (
                        clientData?.isDeleted ||
                        clientData?.onboardingStatus === 'Rejected' ||
                        clientData?.status !== 'Active'
                    ) {
                        logout();
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="!font-inter">
            {!isLoading && token && (
                <ScrollIntoView>
                    <div className="flex flex-col h-screen lg:!gap-[0.5px] dark:lg:bg-brand-black lg:bg-[#f4f4f5]">
                        {shouldShowHeader && (
                            <Header setSelectedLogo={setSelectedLogo} selectedLogo={selectedLogo} />
                        )}
                        <AnimationOnScroll
                            animateIn="animate__fadeInUpCustom"
                            duration={1.2}
                            className="flex-1 bg-rootStyle-bg">
                            <div className=" h-full lg:mb-0 mb-16 lg:mt-[2px]">
                                {props.children}
                            </div>
                        </AnimationOnScroll>
                        {windowWidth < 1100 && <Footer />}
                    </div>
                </ScrollIntoView>
            )}
            {!isLoading && !token && <Navigate to="/" />}
        </div>
    );
}

export default React.memo(Layout);
